export default "__VITE_ASSET__20wVPFg2__"